module.exports = __webpack_public_path__ + "static/media/photo_accessories.c44b1a54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SideImage/photo_accessories.jpg
// module id = 392
// module chunks = 0